<template>
    <div>
        <h3 class="my-auto">
             <b-button @click.prevent="invoice_close" variant="outline-primary">&lt; Return to list</b-button>
            Invoice {{ invoiceId }}
        </h3>
        <b-card no-body class="border-0 mx-0 px-0 pl-0 pr-0">
            <b-row>
                <b-form 
                    class="col-xs-12 col-sm-6 col-lg-4 mt-2" 
                    autocomplete=off 
                    @submit.stop.prevent
                >
                    <b-form-group
                        label="Invoice number"
                    >
                        <b-form-input  
                            class="form-control"
                            v-model="invoice_number"
                            readonly
                        >
                        </b-form-input>
                    </b-form-group>
                    <b-form-group label="Invoice date">                
                        <b-form-input  
                            class="form-control"
                            v-model="invoice_date"
                            readonly
                        >
                        </b-form-input>
                    </b-form-group>
                    <b-form-group label="Invoice due date">
                        <b-form-input  
                            class="form-control"
                            v-model="invoice_due_date"
                            readonly
                        >
                        </b-form-input>
                    </b-form-group>
                    <b-form-group label="Invoice reference">
                        <b-form-input  
                            class="form-control"
                            v-model="invoice_reference"
                            v-on:change="savefield('g_consultantinvoices',invoiceId,'invoice_reference',invoice_reference)" 
                        >
                        </b-form-input>
                    </b-form-group>                    
                    <b-form-group label="Invoice address">
                        <b-form-input  
                            class="form-control"
                            v-model="invoice_name"
                            placeholder="Invoice name"
                            v-on:change="savefield('g_consultantinvoices',invoiceId,'invoice_name',invoice_name)" 
                        >
                        </b-form-input>
                        <b-form-input  
                            class="form-control mt-2"
                            v-model="invoice_company"
                            placeholder="Invoice company"
                            v-on:change="savefield('g_consultantinvoices',invoiceId,'invoice_company',invoice_company)" 
                        >
                        </b-form-input>   
                        <b-form-input  
                            class="form-control mt-2"
                            v-model="invoice_address_1"
                            placeholder="Invoice address 1"
                            v-on:change="savefield('g_consultantinvoices',invoiceId,'invoice_address_1',invoice_address_1)" 
                        >
                        </b-form-input>
                        <b-form-input  
                            class="form-control mt-2"
                            v-model="invoice_address_2"
                            placeholder="Invoice address 2"
                            v-on:change="savefield('g_consultantinvoices',invoiceId,'invoice_address_2',invoice_address_2)" 
                        >
                        </b-form-input>
                        <b-form-input  
                            class="form-control mt-2"
                            v-model="invoice_zip_code"
                            placeholder="Invoice zip code"
                            v-on:change="savefield('g_consultantinvoices',invoiceId,'invoice_zip_code',invoice_zip_code)" 
                        >
                        </b-form-input>
                        <b-form-input  
                            class="form-control mt-2"
                            v-model="invoice_city"
                            placeholder="Invoice city"
                            v-on:change="savefield('g_consultantinvoices',invoiceId,'invoice_city',invoice_city)" 
                        >
                        </b-form-input>                                                                                                 
                    </b-form-group>
                </b-form>
                <b-form 
                    class="col-xs-12 col-sm-6 col-lg-4 mt-2" 
                    autocomplete=off 
                    @submit.stop.prevent
                >            
                    <b-form-group label="Invoice amount">
                        <b-form-input  
                            class="form-control"
                            v-model="invoice_amount"
                            readonly
                        >
                        </b-form-input>
                    </b-form-group>
                    <b-form-group label="VAT amount">
                        <b-form-input  
                            class="form-control"
                            v-model="invoice_vat_amount"
                            readonly
                        >
                        </b-form-input>
                    </b-form-group>
                    <b-form-group label="Invoice status">
                        <b-form-select  
                            class="form-control"
                            v-model="invoice_status"
                            :options="invoicestatuses"
                            readonly
                        >
                        </b-form-select>
                    </b-form-group>                    
                    <b-form-group label="Paid amount">
                        <b-form-input  
                            class="form-control"
                            v-model="invoice_paid_amount"
                            v-on:change="savefield('g_consultantinvoices',invoiceId,'invoice_paid_amount',invoice_paid_amount)" 
                        >
                        </b-form-input>
                    </b-form-group>
                    <b-form-group label="Payment method">
                        <b-form-select  
                            class="form-control"
                            v-model="invoice_payment_method_id"
                            :options="paymentmethods"
                            readonly
                        >
                        </b-form-select>
                    </b-form-group>
                    <b-form-group label="Payment transaction id">
                        <b-form-input  
                            class="form-control"
                            v-model="invoice_payment_reference"
                            v-on:change="savefield('g_consultantinvoices',invoiceId,'invoice_payment_reference',invoice_payment_reference)" 
                        >
                        </b-form-input>
                    </b-form-group>                                                         
                </b-form> 
            </b-row>
        </b-card>
    </div>
</template>
<script>

export default {
    name: 'Invoice',
    props: [
        'invoiceId',
    ],
    data: function() {
        return {
            invoice_number: '',
            invoice_date: '',
            invoice_due_date: '',
            invoice_reference: '',
            invoice_amount: 0,
            invoice_vat_amount: 0,
            invoice_paid_amount: 0,
            invoice_status: 0,
            invoice_payment_method_id: 0,
            invoice_payment_reference: '',
            invoice_text: '',
            invoice_type: '',
            invoice_record_id: '',
            invoice_name: '',
            invoice_company: '',
            invoice_address_1: '',
            invoice_address_2: '',
            invoice_zip_code: '',
            invoice_city: '',
            paymentmethods: [],
            invoicestatuses: [
                { value: 0, text: 'No status'},
                { value: 1, text: 'Created' },
                { value: 2, text: 'Processed' },
            ],
            survey_name: '',
            surver_number_members: 0,
        }
    },
    mounted() {
        this.paymentmethods_get();
    },
    watch: {
        invoiceId() {
            this.invoice_get();
        }
    },
    methods: {
        savefield(tablename,id,fieldname,value) {
            if (fieldname.indexOf('_date') != -1) {
                value = this.format_date(value);
            }
            if ( id > 0 ) { 
                var record = {
                    id: id,
                    [fieldname]: value,
                }
                this.$store.dispatch('field_save', { tablename: tablename,record: record })
                .then(() => {
                    this.invoice_changed();
                });
            }
        },        
        paymentmethods_get() {
            this.$store.dispatch("records_readall", { table_name: 'g_paymentmethods' })
            .then((resp) => {
                var p = resp.data.result.map( (r) => {
                    return {
                        value: r.id,
                        text: r.paymentmethod_name,
                    }
                });
                this.paymentmethods = p;
            });
        },
        invoice_get() {
            if (this.invoiceId != 0) {
                this.$store.dispatch("record_read", { table_name: 'g_consultantinvoices', id: this.invoiceId })
                .then((resp) => {
                    const invoice = resp.data;
                    this.invoice_number = invoice.invoice_number;
                    this.invoice_date = invoice.invoice_date;
                    this.invoice_due_date = invoice.invoice_due_date;
                    this.invoice_reference = invoice.invoice_reference;
                    this.invoice_amount = invoice.invoice_amount;
                    this.invoice_vat_amount = invoice.invoice_vat_amount;
                    this.invoice_paid_amount = invoice.invoice_paid_amount;
                    this.invoice_status = invoice.invoice_status;
                    this.invoice_payment_method_id = invoice.invoice_payment_method_id;
                    this.invoice_payment_reference = invoice.invoice_payment_reference;
                    this.invoice_text = invoice.invoice_text;
                    this.invoice_type = invoice.invoice_type;
                    this.invoice_record_id = invoice.invoice_record_id;
                    this.invoice_name = invoice.invoice_name;
                    this.invoice_company = invoice.invoice_company;
                    this.invoice_address_1 = invoice.invoice_address_1;
                    this.invoice_address_2 = invoice.invoice_address_2;
                    this.invoice_zip_code = invoice.invoice_zip_code;
                    this.invoice_city = invoice.invoice_city;
                    this.survey_get(invoice.invoice_record_id);
                })
            }
        },
        survey_get(survey_id) {
            if (survey_id != 0) {
                this.$store.dispatch("record_read", { table_name: 'g_surveys', id: survey_id })
                .then((resp) => {
                    const survey = resp.data;
                    this.survey_name = survey.survey_name;
                })
            }
        },
        invoice_close() {
            this.$emit("invoiceClose");  
        },
        invoice_changed() {
            this.$emit("invoiceChange");
        }
    }   
    
}


</script>
<style scoped>

</style>